(function breakpoints($) {

    // var $breakpoint = $('<div class="breakpoint">' + window.innerWidth + 'px</div>');
    // $('body').prepend($breakpoint);
    // $( window ).resize(function() {
    //     $breakpoint.html(window.innerWidth + 'px');
    // });

}(jQuery));
